import {
  byHideOnPredicate,
  HideOnConditionProps,
} from '../../utils/filterPredicates/hideOn';

type MapNavItemsAdditionalData = HideOnConditionProps & {
  activeCommand?: string;
  mode?: 'default' | 'small' | 'wide';
};

export function mapNavItems(
  items: any,
  routes: any,
  additionalData: MapNavItemsAdditionalData = {}
) {
  const filterPredicate = filterOutNavItems(additionalData);
  return items
    .map((item: any) => {
      if (item.routes?.length) {
        const isActive =
          item.routes.some((route: any) => routes.includes(route.route_link)) ||
          routes.includes(item.route_link);

        let routesFromItem = item.routes;
        if (isActive) {
          routesFromItem = routesFromItem.map((itemRoute: any) => ({
            ...itemRoute,
            state: routes.includes(itemRoute.route_link)
              ? 'active'
              : 'inactive',
          }));
        }

        return {
          ...item,
          ...(isActive && { state: 'active' }),
          routes: routesFromItem.filter(filterPredicate),
        };
      }

      const isActive = additionalData.activeCommand
        ? additionalData.activeCommand === item.title
        : routes.includes(item.route_link);

      return { ...item, state: isActive ? 'active' : 'inactive' };
    })
    .filter(filterPredicate);
}

const filterOutNavItems = (additionalData: MapNavItemsAdditionalData = {}) => (
  route: any
) => {
  switch (additionalData.mode) {
    case 'default':
    default: {
      return byHideOnPredicate(additionalData)(route);
    }
    case 'small': {
      return !route.hide_on?.includes('Small');
    }
    case 'wide': {
      return !route.hide_on?.includes('Small');
    }
  }
};
